import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import Users from "./pages/Users";
import Main from "./components/layout/Main";
import ErrorBoundary from "./components/ErrorBoundary";
import Login from "./pages/login/LoginPage";
import CreteItems from "./pages/Store/CreateItems/CreateItems";
import EditStock from "./pages/Store/EditStock/EditStock";
import BulkUploadItems from "./pages/Store/CreateItems/BulkUploadItems";
import Cookies from "js-cookie";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import ManageProject from "./pages/PM/ManageProject";
import InspectionForm from "./pages/PM/InspectionForm";
import StockTracker from "./pages/STOCK_CHECK/StockTracker";
import Dashboard from './pages/PM/Dashboard';
import CreateJob from './pages/PM/CreateJob';
import JobDetails from './pages/PM/JobDetails';
import Jobs from './pages/PM/Jobs';
import SupervisorDashboard from './pages/PM/SupervisorDashboard';

import PwaInstallPrompt from "./components/pwa/PwaInstallPrompt";

function ProtectedLayout({ children }) {
  const rememberedUser = Cookies.get("rememberedUser");
  if (!rememberedUser) {
    return <Redirect to="/" />;
  }
  return (
    <ErrorBoundary>
      <Main>{children}</Main>
    </ErrorBoundary>
  );
}

function App() {
  let rememberedUser = Cookies.get("rememberedUser");
  const is_cookie_set = Boolean(rememberedUser);

  useEffect(() => {
    if (is_cookie_set && window.location.pathname === '/') {
      window.location.href = "/items"; // Redirect to '/items' if a valid cookie exists
    }
  }, [is_cookie_set]);

  return (
    <div className="App">
      <PwaInstallPrompt />
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/sign-up" component={SignUp} />
        <Route>
          <ProtectedLayout>
            <Switch>
              <Route exact path="/items" component={EditStock} />
              <Route exact path="/profile" component={Profile} />
              <Route exact path="/users" component={Users} />
              <Route exact path="/add-items" component={CreteItems} />
              <Route exact path="/add-items-csv" component={BulkUploadItems} />
              <Route exact path="/manage-project" component={ManageProject} />
              <Route exact path="/inspection-form" component={InspectionForm} />
              <Route exact path="/stock-tracker" component={StockTracker} />
              {/* Project Management pages */}
              <Route path="/pm/dashboard" component={Dashboard} />
              <Route path="/pm/jobs" component={Jobs} />
              <Route path="/pm/job/:jobId" component={JobDetails} />
              <Route path="/pm/mytasks" component={SupervisorDashboard} />
              <Redirect to="/items" />
            </Switch>
          </ProtectedLayout>
        </Route>
      </Switch>
    </div>
  );
}

export default App;
